import { render, staticRenderFns } from "./PcFooter.vue?vue&type=template&id=4b2e78c1&scoped=true"
import script from "./PcFooter.vue?vue&type=script&lang=js"
export * from "./PcFooter.vue?vue&type=script&lang=js"
import style0 from "./PcFooter.vue?vue&type=style&index=0&id=4b2e78c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.32_css-loader@6.11.0_webpack@5.106.0__lodash@4_fb6f2845f82ca867f83f204a66169969/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2e78c1",
  null
  
)

export default component.exports